import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {UpdateBatchProcedure} from 'domain/usecases/private/refund/request/update-batch-procedure';
import {RemoteRefundUpdateBatchProcedure} from 'data/usecases/private/refund/request/remote-update-batch-procedure';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeUpdateBatchProcedure = (): UpdateBatchProcedure =>
	new RemoteRefundUpdateBatchProcedure(
		makeBFFApiUrl(RefundFlowEndPoints.updateBatchProcedure),
		makeAuthorizeHttpClientDecorator(),
	);
